import React from 'react';

export default function VolcanoPeakSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Base brim */}
      <ellipse cx="20" cy="34" rx="17" ry="3" fill="#212121" />
      {/* Volcano cone */}
      <path d="M8 34 L16 10 L24 10 L32 34 Z" fill="#424242" />
      {/* Lighter face */}
      <path d="M16 10 L24 10 L20 14 Z" fill="#616161" />
      {/* Crater rim */}
      <ellipse cx="20" cy="10" rx="4" ry="1.5" fill="#1B1B1B" />
      <ellipse cx="20" cy="10" rx="3" ry="1" fill="#FF5722" />
      {/* Lava drips on cone */}
      <path d="M16 12 C16 14 14 16 14 18 C14 20 16 20 16 18 Z" fill="#FF6F00" />
      <path d="M24 12 C24 15 26 17 26 20 C26 22 24 22 24 20 Z" fill="#FF6F00" />
      <path d="M20 14 C20 18 18 22 18 26 C18 28 20 28 20 26 Z" fill="#FF8F00" />
      {/* Lava drip highlights */}
      <circle cx="14.5" cy="19" r="1" fill="#FFEB3B" opacity="0.7" />
      <circle cx="25.5" cy="21" r="1" fill="#FFEB3B" opacity="0.7" />
      {/* Smoke puff */}
      <circle cx="20" cy="6" r="2" fill="#757575" opacity="0.5" />
      <circle cx="22" cy="4" r="1.5" fill="#9E9E9E" opacity="0.4" />
    </svg>
  );
}
